import React, { Fragment, useState, useEffect } from 'react';
import { Table, message, Button, Modal, Popconfirm, DatePicker, Select } from 'antd';
import { DeleteOutlined } from "@ant-design/icons";
import { Col, Row } from 'react-bootstrap';
import Card from '../../../components/bootstrap/card';
import { determineRemark } from '../utils/RemarkAllocation';
import { getRodtepImportDataService } from '../../../services/RodtepReportService';
import { getAllScripTransactionService } from '../../../services/ScripTradingService';
import { getReportSummaryData, getAllAdminIECsService } from '../../../services/FileDataService';
import { getBRCorelationService } from '../../../services/MasterService';
import { getTodaysDate, formatToTwoDecimals } from '../../../utilities/utils';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import axios from "axios";
import { SERVER_URL } from "../../../const";
import dayjs from 'dayjs';
import PurchaseModal from './CreatePurchase'
import SellScrip from './SellScrip';
import { useLocation } from 'react-router-dom';
import ReportDateFilter from '../../../components/ReportDateFilter';

import useColumnVisibility from '../../../hooks/useColumnVisibility';
import ColumnSelector from '../../../components/common/ColumnSelector';

const { RangePicker } = DatePicker;

const RodetepScripLedger = ({ data }) => {
  const tableStyles = `
    .rodtep-ledger-table .ant-table-thead > tr > th,
    .rodtep-ledger-summary-table .ant-table-thead > tr > th,
    .transactions-modal-table .ant-table-thead > tr > th {
      white-space: normal !important;
      word-break: break-word !important;
      overflow: visible !important;
      text-overflow: unset !important;
      vertical-align: middle !important;
      line-height: 1.3 !important;
      padding-top: 8px !important;
      padding-bottom: 8px !important;
    }
    .rodtep-ledger-table .ant-table-tbody > tr > td,
    .rodtep-ledger-summary-table .ant-table-tbody > tr > td,
    .transactions-modal-table .ant-table-tbody > tr > td {
      white-space: nowrap;
    }
    .rodtep-ledger-table .ant-table-container,
    .rodtep-ledger-summary-table .ant-table-container,
    .transactions-modal-table .ant-table-container {
      overflow-x: auto !important;
    }
    .rodtep-ledger-table .ant-table-header,
    .rodtep-ledger-summary-table .ant-table-header,
    .transactions-modal-table .ant-table-header {
      overflow: hidden !important;
    }
    .rodtep-ledger-table .ant-table-sticky-holder,
    .rodtep-ledger-summary-table .ant-table-sticky-holder,
    .transactions-modal-table .ant-table-sticky-holder {
      overflow: hidden !important;
    }
  `;
  const location = useLocation();
  const [jsonData, setJsonData] = useState([]);
  const [isLoading2, setIsLoading2] = useState(false);
  const [summaryDashboardData, setSummaryDashboardData] = useState([]);
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [IECOptions, setIECOptions] = useState([]);
  const userRole = localStorage.getItem('role');
  const [selectedIEC, setSelectedIEC] = useState(localStorage.getItem('iec_no'));
  const [selectedIECName, setSelectedIECName] = useState(localStorage.getItem('name'));
  const [messageApi, contextHolder] = message.useMessage();
  const [isValid, setIsValid] = useState(true);
  const [billNo, setBillNo] = useState('');
  const [billNoOptions, setBillNoOptions] = useState([]);
  const [selectedBillNo, setSelectedBillNo] = useState('');
  const [branchCodeNames, setBranchCodeNames] = useState([]);
  const [selectedBranchCodes, setSelectedBranchCodes] = useState([]);

  const currentYear = dayjs().year();
  const defaultFrom = dayjs(`${currentYear}-01-01`);
  const defaultTo = dayjs(`${currentYear}-12-31`);
  const [dates, setDates] = useState(() => {
    if (location.state?.passedDates?.length === 2) {
      return [
        dayjs(location.state.passedDates[0]),
        dayjs(location.state.passedDates[1]),
      ];
    }
    return [defaultFrom, defaultTo];
  });

  const today = new Date();
  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const year = today.getFullYear();
  const reportType = 'BRC';
  const formattedDate = `${day}-${month}-${year}`;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showSellModal, setShowSellModal] = useState(false);
  const [sellModalData, setSellModalData] = useState(null);

  const fetchTransactions = async (scrip_number, scrip_issue_date, scrip_expiry_date) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${SERVER_URL}/scrip-transactions/${scrip_number}?scrip_issue_date=${scrip_issue_date}&scrip_expiry_date=${scrip_expiry_date}`,
        { headers: { Authorization: 'Bearer ' + token } }
      );
      if (response.status === 404 || response.data.length <= 0) {
        setModalData([]);
        throw new Error('Not transactions found for this scrip : ' + scrip_number);
      } else {
        setModalData(response.data);
        setIsModalOpen(true);
      }
    } catch (error) {
      console.error('Error fetching transactions:', error);
      setModalData([]);
      errorFunction('Not transactions found for this scrip : ' + scrip_number);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { title: 'BUSINESS UNIT', dataIndex: 'business_unit', key: 'business_unit', header: 'BUSINESS UNIT', width: 160, fixed: 'left' },
    { title: 'PLANT NAME', dataIndex: 'plant_name', key: 'plant_name', header: 'PLANT NAME', width: 150, fixed: 'left' },
    { title: 'RD SCRIP NO.', dataIndex: 'scrip_number', key: 'scrip_number', header: 'RD SCRIP NO.', width: 150 },
    {
      title: 'RD SCRIP DT.',
      dataIndex: 'scrip_issue_date',
      key: 'scrip_issue_date',
      header: 'RD SCRIP DT.',
      width: 120,
      render: (text, record) => {
        if (record.scrip_issue_date) return formatDateToDDMMYY(record.scrip_issue_date);
      },
    },
    {
      title: 'RD SCRIP AMT.',
      dataIndex: 'scrip_issue_amount',
      key: 'scrip_issue_amount',
      header: 'RD SCRIP AMT.',
      align: 'right',
      width: 130,
      render: (text) => formatToTwoDecimals(text),
    },
    { title: 'IEC/BR CODE', dataIndex: 'iec_br', key: 'iec_br', header: 'IEC/BR CODE', width: 120 },
    { title: 'PORT', dataIndex: 'port', key: 'port', header: 'PORT', width: 80 },
    { title: 'REF. CODE', dataIndex: 'reference_code', key: 'reference_code', header: 'REF. CODE', width: 120 },
    { title: 'BOE NO.', dataIndex: 'be_no', key: 'be_no', header: 'BOE NO.', width: 110 },
    {
      title: 'BOE DT.',
      dataIndex: 'be_date',
      key: 'be_date',
      header: 'BOE DT.',
      width: 120,
      render: (text, record) => {
        if (record.be_date) return formatDateToDDMMYY(record.be_date);
      },
    },
    {
      title: 'DUTY DEBITED',
      dataIndex: 'debit_duty',
      key: 'debit_duty',
      header: 'DUTY DEBITED',
      align: 'right',
      width: 130,
      render: (text) => formatToTwoDecimals(text),
    },
  ];

  const { visibleKeys, setVisibleKeys, filteredColumns, resetToDefault } =
    useColumnVisibility('RodtepScripLedgerReport', columns);

  const onSellScrip = async (scrip) => {
    setShowSellModal(true);
    setSellModalData(scrip);
  };

  const transactionDetailsColumns = [
    { title: 'Scrip Number', dataIndex: 'scrip_number', key: 'scrip_number', header: 'Scrip Number' },
    { title: 'Issue Date', dataIndex: 'scrip_issue_date', key: 'scrip_issue_date', header: 'Issue Date' },
    { title: 'Expiry Date', dataIndex: 'scrip_expiry_date', key: 'scrip_expiry_date', header: 'Expiry Date' },
    { title: 'Issue Amt.', dataIndex: 'scrip_issue_amount', key: 'scrip_issue_amount', header: 'Issue Amt.', render: (text) => formatToTwoDecimals(text) },
    { title: 'Trade Type', dataIndex: 'trading_type', key: 'trading_type', header: 'Trade Type' },
    { title: 'Value', dataIndex: 'value', key: 'value', header: 'Value', render: (text) => formatToTwoDecimals(text) },
    { title: 'Rate', dataIndex: 'rate', key: 'rate', header: 'Rate', render: (text) => formatToTwoDecimals(text) },
    { title: 'Trading Details', dataIndex: 'trading_details', key: 'trading_details', header: 'Trading Details' },
    { title: 'User Name', dataIndex: 'name', key: 'name', header: 'User Name' },
    { title: 'IEC', dataIndex: 'iec_no', key: 'iec_no', header: 'IEC' },
  ];

  const dashboardReportSummaryColumns = [
    { title: 'RD SCRIP NO.', dataIndex: 'scrip_number', key: 'scrip_number', header: 'RD SCRIP NO.', width: 150 },
    { title: 'RD SCRIP DT.', dataIndex: 'scrip_issue_date', key: 'scrip_issue_date', header: 'RD SCRIP DT.', width: 120 },
    {
      title: 'RD SCRIP AMT.',
      dataIndex: 'scrip_issue_amount',
      key: 'scrip_issue_amount',
      header: 'RD SCRIP AMT.',
      align: 'right',
      width: 130,
      render: (text) => formatToTwoDecimals(text),
    },
    {
      title: 'DUTY DEBITED',
      dataIndex: 'debit_duty',
      key: 'debit_duty',
      header: 'DUTY DEBITED',
      align: 'right',
      width: 130,
      render: (text) => formatToTwoDecimals(text),
    },
    {
      title: 'BALANCE',
      dataIndex: 'balance_amt',
      key: 'balance_amt',
      header: 'BALANCE',
      align: 'right',
      width: 130,
      render: (text) => formatToTwoDecimals(text),
    },
    { title: 'VALID TILL', dataIndex: 'scrip_expiry_date', key: 'scrip_expiry_date', header: 'VALID TILL', width: 120 },
    { title: 'VALID FOR (DAYS)', dataIndex: 'valid_for_days', key: 'valid_for_days', header: 'VALID FOR (DAYS)', align: 'right', width: 140 },
    {
      title: 'SCRIP SOLD AMT.',
      dataIndex: 'sold_amt',
      key: 'sold_amt',
      header: 'SCRIP SOLD AMT.',
      align: 'right',
      width: 140,
      render: (text) => formatToTwoDecimals(text),
    },
    {
      title: 'TRANSACTION DETAILS',
      dataIndex: 'transaction_days',
      key: 'transaction_days',
      align: 'right',
      width: 180,
      render: (_, record) => (
        <Button
          size="small"
          className="cip-btn-submit"
          style={{
            borderRadius: '6px',
            fontSize: '12px',
          }}
          onClick={() =>
            fetchTransactions(record.scrip_number, record.scrip_issue_date, record.scrip_expiry_date)
          }
        >
          View Transaction Details
        </Button>
      ),
    },
    {
      title: 'Action',
      dataIndex: 'sell_action',
      key: 'sell_action',
      align: 'right',
      width: 100,
      render: (_, record) => {
        const isDisabled = !(record.valid_for_days > 0 && record.balance_amt > 0);
        return (
          <Button
            type="primary"
            className="cip-btn-primary"
            size="small"
            style={{
              padding: '0 16px',
              fontSize: '12px',
              fontWeight: 700,
              borderRadius: '6px',
              height: '28px',
            }}
            disabled={isDisabled}
            onClick={() => onSellScrip(record)}
          >
            Sell
          </Button>
        );
      },
    },
  ];

  const getSummaryDashboard = async () => {
    const filters = {
      from_date: dates?.[0] ? dayjs(dates[0]).format('YYYY-MM-DD') : null,
      to_date: dates?.[1] ? dayjs(dates[1]).format('YYYY-MM-DD') : null,
      bill_no: billNo || null,
      br_code: selectedBranchCodes || null,
    };
    try {
      setIsLoading2(true);
      const reportTypes = 'RODTEP-ScripLedger';
      const response = await getReportSummaryData(reportTypes, filters, selectedIEC);
      if (response && response.data) {
        setSummaryDashboardData(response.data);
        const uniqueNos = [...new Set(response.data.map((item) => item.scrip_number))];
        let i = 0;
        const options = uniqueNos.map((item) => ({
          value: `${item}`,
          label: `${item}`,
          key: i++,
        }));
        setBillNoOptions(options);
      } else {
        console.log('getSummaryDashboard :: no response');
      }
      setIsLoading2(false);
    } catch (err) {
      setIsLoading2(false);
      console.log(err);
    }
  };

  const fetchData = async () => {
    const filters = {
      from_date: dates?.[0] ? dayjs(dates[0]).format('YYYY-MM-DD') : null,
      to_date: dates?.[1] ? dayjs(dates[1]).format('YYYY-MM-DD') : null,
      bill_no: billNo || null,
      br_code: selectedBranchCodes || null,
    };
    try {
      const response = await getRodtepImportDataService(selectedIEC, filters);
      setJsonData(response);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // ─── useEffect 1: on mount ─────────────────────────────────────────────────
  // Guard added: only call getBRCorelationService if selectedIEC is not null
  // (prevents superadmin from firing a request with null IEC on first load)
  useEffect(() => {
    if (userRole === 'superadmin' || userRole === 'group_head') {
      getAdminIEC();
    }
    if (userRole === 'admin' || userRole === 'user') {
      fetchData();
      getSummaryDashboard();
    }
    if (selectedIEC) {
      getBRCorelationService(selectedIEC).then((response) => {
        setBranchCodeNames(response);
      });
    }
  }, []);

  // ─── useEffect 2: re-fetch branch codes when superadmin selects an IEC ────
  // This was missing — branch codes never updated after IEC selection
  useEffect(() => {
    if (selectedIEC) {
      getBRCorelationService(selectedIEC).then((response) => {
        setBranchCodeNames(response);
      });
    }
  }, [selectedIEC]);

  const preprocessData = (data) => {
    return data.map((record) => {
      if (record.sb_date) {
        const sbDate = new Date(record.sb_date);
        const fiscalYearStartYear = sbDate.getMonth() >= 3 ? sbDate.getFullYear() : sbDate.getFullYear() - 1;
        const fiscalYearEndYear = fiscalYearStartYear + 1;
        const fiscalYear = `AM${fiscalYearEndYear.toString().slice(-2)}`;
        record.FY = fiscalYear;
        record.sb_date = formatDateToDDMMYY(sbDate);
      } else {
        record.FY = '';
        record.sb_date = '';
        record.sbDate = '';
      }
      record.Remark = determineRemark(record, reportType);
      return record;
    });
  };

  function formatDateToDDMMYY(dateString) {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    const d = String(date.getDate()).padStart(2, '0');
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const y = String(date.getFullYear()).slice(-2);
    return `${d}/${m}/${y}`;
  }

  const getDateOnly = (dateString) => {
    if (dateString && dateString.length !== 0) {
      return new Date(dateString);
    }
    return '';
  };

  const onPurchase = () => {
    setShowPurchaseModal(true);
  };

  const handleDateChange = (value) => {
    setDates(value || []);
    if (value && value.length === 2) {
      const from_date = value[0];
      const to_date = value[1];
      if (!from_date || !to_date) {
        setIsValid(false);
        return;
      }
      const oneYearLater = from_date.add(1, 'year');
      if (to_date.isAfter(oneYearLater)) {
        message.error('The selected duration should not exceed 1 year.');
        setIsValid(false);
        return;
      }
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  };

  const handleSubmit = () => {
    if (!selectedIEC) {
      message.error('Please select an IEC');
      return;
    }
    if (dates.length === 2 && isValid) {
      getSummaryDashboard();
      fetchData();
    } else {
      message.error('Please select a valid date range.');
    }
  };

  const getAdminIEC = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await getAllAdminIECsService(token);
      if (response?.data) {
        const options = response.data.map((item, index) => ({
          value: `${item.iec_no};${item.fullname}`,
          label: `${item.iec_no} (${item.fullname})`,
          key: index,
        }));
        setIECOptions(options);
      }
    } catch (err) {
      message.error('Failed to load IEC list');
    }
  };

  const handleIECSelection = (val) => {
    if (val) {
      const [iec_no, iec_name] = val.split(';');
      setSelectedIEC(iec_no);
      setSelectedIECName(iec_name);
    } else {
      setSelectedIEC(null);
      setSelectedIECName('');
    }
  };

  const handleBillNoSelection = (val) => {
    if (val) {
      setSelectedBillNo(val);
      setBillNo(val);
    } else {
      setSelectedBillNo('');
      setBillNo('');
    }
  };

  const handleBranchCodeSelection = (values) => {
    setSelectedBranchCodes(values);
  };

  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const summaryWorksheet = workbook.addWorksheet('Summary');
    const worksheet = workbook.addWorksheet('Data');
    const transactionWorksheet = workbook.addWorksheet('Trading Details');
    const exportData = jsonData;

    summaryWorksheet.columns = filteredSummaryColumns
      .filter((col) => col.dataIndex !== 'transaction_days' && col.dataIndex !== 'sell_action')
      .map((col) => ({
        header: col.title,
        key: col.dataIndex,
        width: Math.floor((col.width || 150) / 7),
      }));
    summaryWorksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFC000' } };
      cell.alignment = { vertical: 'middle' };
    });
    summaryDashboardData.forEach((obj) => {
      summaryWorksheet.addRow({
        ...obj,
        scrip_issue_date: getDateOnly(obj.scrip_issue_date),
        scrip_expiry_date: getDateOnly(obj.scrip_expiry_date),
      });
    });

    worksheet.columns = filteredColumns.map((col) => ({
      header: col.title,
      key: col.dataIndex,
      width: Math.floor((col.width || 150) / 7),
    }));
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFC000' } };
      cell.alignment = { vertical: 'middle' };
    });
    exportData.forEach((obj) => {
      worksheet.addRow({
        ...obj,
        scrip_issue_date: getDateOnly(obj.scrip_issue_date),
        be_date: getDateOnly(obj.be_date),
        debit_duty: obj.debit_duty ? parseFloat(obj.debit_duty) : '',
      });
    });

    const tradingData = await getAllScripTransactionService();
    transactionWorksheet.columns = transactionDetailsColumns.map((col) => ({
      header: col.title,
      key: col.dataIndex,
      width: 20,
    }));
    transactionWorksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFC000' } };
      cell.alignment = { vertical: 'middle' };
    });
    tradingData.forEach((obj) => {
      transactionWorksheet.addRow({
        ...obj,
        scrip_issue_date: getDateOnly(obj.scrip_issue_date),
        scrip_expiry_date: getDateOnly(obj.scrip_expiry_date),
      });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `Lucrative's CIP DSS - RoDTEP Scrip Ledger as on ${getTodaysDate()} of ${selectedIEC}.xlsx`);
  };

  const errorFunction = (content) => {
    messageApi.open({ type: 'error', content });
  };

  const successFunction = (content) => {
    messageApi.open({ type: 'success', content });
    getSummaryDashboard();
  };

  const filteredSummaryColumns = dashboardReportSummaryColumns.filter((col) => {
    const key = String(col.dataIndex || col.key);
    const isDefinedInDetail = columns.some((c) => String(c.dataIndex || c.key) === key);
    return isDefinedInDetail ? visibleKeys.includes(key) : true;
  });

  return (
    <Fragment>
      <style>{tableStyles}</style>
      {contextHolder}
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">
                  Lucrative's CIP DSS - RoDTEP Scrip Ledger as on {formattedDate} of {selectedIECName}
                </h4>
              </div>
              <div className="d-flex align-items-center gap-2">
                <ColumnSelector
                  allColumns={columns}
                  visibleKeys={visibleKeys}
                  setVisibleKeys={setVisibleKeys}
                  onReset={resetToDefault}
                />
                <button className="btn btn-primary" onClick={onPurchase}>
                  Purchase
                </button>
                <button className="btn btn-primary cip-btn-submit" onClick={exportToExcel}>
                  Export to Excel
                </button>
              </div>
            </Card.Header>

            <Card.Body className="d-flex justify-content-start align-items-center gap-2 ps-4">
              {(userRole === 'superadmin' || userRole === 'group_head') && (
                <Select
                  showSearch
                  placeholder="Select IEC"
                  onChange={handleIECSelection}
                  allowClear
                  options={IECOptions}
                  style={{ width: '300px' }}
                />
              )}
              <ReportDateFilter dates={dates} onChange={handleDateChange} />
              <Select
                showSearch
                placeholder="Select Auth No"
                value={selectedBillNo}
                allowClear
                style={{ width: 250 }}
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                onChange={handleBillNoSelection}
                options={billNoOptions}
              />
              <Select
                mode="multiple"
                allowClear
                style={{ width: 250 }}
                placeholder="Select Branch Code"
                onChange={handleBranchCodeSelection}
                options={branchCodeNames.map((item) => ({
                  value: item.branch_code,
                  label: `${item.branch_code} / ${item.plant_name} (${item.business_unit})`,
                }))}
              />
              <Button type="primary" className="cip-btn-submit" onClick={handleSubmit}>
                Submit
              </Button>
            </Card.Body>

            <Card.Body className="px-0 report-page">
              <Table
                className="rodtep-ledger-summary-table"
                columns={filteredSummaryColumns}
                dataSource={summaryDashboardData}
                pagination={false}
                loading={isLoading2}
                bordered
                scroll={{ x: 'max-content' }}

              />
              <hr />
              <Table
                className="rodtep-ledger-table"
                bordered
                columns={filteredColumns}
                dataSource={jsonData}
                pagination={{ showTotal: (total) => `Total ${total} records`, showSizeChanger: true }}
                scroll={{ x: 'max-content' }}

              />
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <SellScrip
        data={sellModalData}
        errorFunction={errorFunction}
        onSuccessFunction={successFunction}
        title="Sell Scrip"
        handleClose={() => { setShowSellModal(false); setSellModalData(null); }}
        open={showSellModal}
      />
      <TransactionsModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        loading={loading}
        modalData={modalData}
        fetchTransactions={fetchTransactions}
      />
      <PurchaseModal
        errorFunction={errorFunction}
        onSuccessFunction={successFunction}
        title="Purchase Scrip"
        handleClose={() => setShowPurchaseModal(false)}
        open={showPurchaseModal}
      />
    </Fragment>
  );
};

export default RodetepScripLedger;


const TransactionsModal = ({ isModalOpen, setIsModalOpen, loading, modalData, fetchTransactions }) => {

  const handleDelete = async (tradingId) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Unauthorized: No token found');
      const response = await axios.delete(`${SERVER_URL}/delete_transaction/${tradingId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.status === 200) {
        message.success('Transaction deleted successfully');
      } else {
        throw new Error('Failed to delete transaction');
      }
    } catch (error) {
      console.error('Error deleting transaction:', error);
      message.error(error.response?.data?.detail || 'Something went wrong');
    } finally {
      fetchTransactions(
        modalData[0]?.scrip_number,
        modalData[0]?.scrip_issue_date,
        modalData[0]?.scrip_expiry_date
      );
    }
  };

  return (
    <Modal
      title="Transaction Details"
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      footer={null}
      width="90%"
    >
      {loading ? (
        <p>Loading...</p>
      ) : (
        <Table
          className="transactions-modal-table"
          bordered
          dataSource={modalData}
          columns={[
            { title: 'Scrip Number', dataIndex: 'scrip_number', key: 'scrip_number', width: 130 },
            { title: 'Issue Amt.', dataIndex: 'scrip_issue_amount', key: 'scrip_issue_amount', width: 120, render: (text) => formatToTwoDecimals(text) },
            { title: 'Trading Type', dataIndex: 'trading_type', key: 'trading_type', width: 140 },
            { title: 'Value', dataIndex: 'value', key: 'value', width: 120, render: (text) => formatToTwoDecimals(text) },
            { title: 'Rate', dataIndex: 'rate', key: 'rate', width: 80, render: (text) => formatToTwoDecimals(text) },
            { title: 'Issue Date', dataIndex: 'scrip_issue_date', key: 'scrip_issue_date', width: 120 },
            { title: 'Expiry Date', dataIndex: 'scrip_expiry_date', key: 'scrip_expiry_date', width: 130 },
            { title: 'Trading Details', dataIndex: 'trading_details', key: 'trading_details', width: 170 },
            { title: 'Created At', dataIndex: 'created_at', key: 'created_at', width: 120 },
            { title: 'User Name', dataIndex: 'name', key: 'name', width: 120 },
            { title: 'IEC', dataIndex: 'iec_no', key: 'iec_no', width: 80 },
            {
              title: 'Del',
              key: 'action',
              fixed: 'right',
              width: 60,
              render: (_, record) => (
                <Popconfirm
                  title="Are you sure to delete this transaction?"
                  onConfirm={() => handleDelete(record.trading_id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <DeleteOutlined style={{ color: 'red', cursor: 'pointer' }} />
                </Popconfirm>
              ),
            },
          ]}
          rowKey="trading_id"
          pagination={{ pageSize: 10, showTotal: (total) => `Total ${total} records`, showSizeChanger: true }}
          scroll={{ x: 'max-content' }}

        />
      )}
    </Modal>
  );
};